import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostMusicPage } from './post-music.page';
import { PostMusicRoutingModule } from './post-music-routing.module';
import {ComponentsModule} from "../../components/components.module";
import {IonicModule} from "@ionic/angular";
import {QuillModule} from "ngx-quill";
import {FormsModule} from "@angular/forms";
import {GoogleMapsModule} from "@angular/google-maps";
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [PostMusicPage],
  imports: [
    CommonModule,
    PostMusicRoutingModule,
    ComponentsModule,
    IonicModule,
    TranslateModule,
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],

          [{'size': ['small', false, 'large', 'huge']}],
        ],
        placerholder: 'Describe la publicación',
      }
    }),
    FormsModule,
    GoogleMapsModule
  ]
})
export class PostMusicModule { }
